import isAfter from 'date-fns/isAfter';
import {AppConfigKeyValueMapVo} from '../../common/shared/api/nicolas/vo/AppConfigKeyValueMapVo.interface';
import {AppBadge} from '../generated/types';

export function createAppBadge(
  appConfigTypeVoMap?: AppConfigKeyValueMapVo
): AppBadge {
  if (!appConfigTypeVoMap) return {};
  const appBadge: AppBadge = {};
  const {
    gift_last_added_date,
    my_news_last_added_date,
    notice_last_added_date,
    helix_gift_last_added_date,
  } = appConfigTypeVoMap;

  // 선물함 마지막 추가일자와 helix 선물 마지막 추가일자 중 최신값을 사용합니다.
  // 선물함 내부에 헬릭스 선물이 추가되었는데 이 날짜는 로컬스토리지에 저장된 날짜와 비교하여 헤더의 red dot 노출 여부에 사용됩니다.
  if (gift_last_added_date || helix_gift_last_added_date) {
    if (gift_last_added_date && helix_gift_last_added_date) {
      appBadge.giftLastAddedDate = isAfter(
        new Date(gift_last_added_date),
        new Date(helix_gift_last_added_date)
      )
        ? gift_last_added_date
        : helix_gift_last_added_date;
    } else {
      appBadge.giftLastAddedDate = gift_last_added_date
        ? gift_last_added_date
        : helix_gift_last_added_date;
    }
  }

  if (my_news_last_added_date) {
    appBadge.myNewsLastAddedDate = my_news_last_added_date;
  }

  if (notice_last_added_date) {
    appBadge.noticeLastAddedDate = notice_last_added_date;
  }

  return appBadge;
}
